import { render, staticRenderFns } from "./FormItemCaptcha.vue?vue&type=template&id=9b0cd790&scoped=true&"
import script from "./FormItemCaptcha.vue?vue&type=script&lang=js&"
export * from "./FormItemCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./FormItemCaptcha.vue?vue&type=style&index=0&id=9b0cd790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0cd790",
  null
  
)

export default component.exports